import { httpClient } from "../../../shared/api/httpClient"
import { ordenarPorNombre } from "../../../shared/utils/funciones"
import { conCacheSesion } from "../../../shared/api/cacheSesion"
import type {
    SucursalesBuscarRequest,
    SucursalesBuscarResult,
    SucursalesPorCompaniaRequest,
    SucursalesPorCompaniaResult,
} from "../types/sucursales.types"

export const sucursalesBuscar = async (dataPOST: SucursalesBuscarRequest): Promise<SucursalesBuscarResult | undefined> => {
    try {

        const res = await httpClient.post("api/compania/ListarCompaniaSucursalSinPrincipal", dataPOST)
        //res.status 201
        if (res.data.status === 1) {
            return {
                status: res.data.status,
                message: res.data.message,
                companias: res.data.resultado,
            }
        }

    } catch (error) {

        if (error.response && error.response.data.status === 0) {
            return {
                status: error.response.data.status,
                message: error.response.data.message,
                companias: []
            };
        }

        return {
            status: -1,
            message: "Error en el servidor",
            companias: []
        };
    }
}

// Sucursales por compañía: mismas para (compañía, estado) durante la sesión -> se cachean
// por token+parámetros para no re-consultar en cada navegación. Ver shared/api/cacheSesion.
export const sucursalesPorCompania = (dataPOST: SucursalesPorCompaniaRequest): Promise<SucursalesPorCompaniaResult | undefined> =>
    conCacheSesion(
        `suc:${(dataPOST as any)?.token}:${(dataPOST as any)?.Codigo}:${(dataPOST as any)?.Estado}`,
        async () => {
            try {
                const res = await httpClient.post("api/compania/ListarCompaniaSucursal", dataPOST)
                //res.status 201
                if (res.data.status === 1) {
                    return {
                        status: res.data.status,
                        sucursales: ordenarPorNombre(res.data.resultado),
                        message: res.data.message,
                    }
                }
            } catch (error) {
                if (error.response && error.response.data.status === 0) {
                    return {
                        status: 0,
                        sucursales: [],
                        message: error.response.data.message,
                    };
                }
                return {
                    status: -1,
                    sucursales: [],
                    message: "Error en el servidor",
                }
            }
        },
        (v) => (v as any)?.status === 1,
    )
